import { useRef, useState } from "react";
import { PaymentResultParams } from "../../../common/types";
import { Button } from "../Elements";
import { FaCopy } from "react-icons/fa";
import PaymentSlipModal from "../PaymentSlipModal";
import { toast } from "react-toastify";



interface Props extends PaymentResultParams {
    goToPayment: (isReset: boolean) => void
}

const PaymentResultV1 = (props: Props) => {
    const { Amount, ErrorCode, ErrorMessage, Installment, Orderid, PaymentId, ReferenceNumber, Status, TransactionId,
        paymentPageType, CurrencySymbol } = props;


    const paymentSlipModalRef = useRef<any>();
    const [isLoading, setIsLoading] = useState(false);
    const isSuccessPayment = Status == "success";
    const isErrorPayment = Status == "fail";
    const isWaitPayment = Status == "wait";

    var header = "Ödemeniz Başarılı";
    var contenttext = "Ödemeniz başarılı bir şekilde alınmıştır. Ödeme bilgileri aşağıdaki gibidir.";
    if (isErrorPayment) {
        header = "Ödemeniz Başarısız!";
        contenttext = "Ödemeniz alınırken hata meydana gelmiştir. Hata bilgileri aşağıdaki gibidir.";
    }
    else if (isWaitPayment) {
        header = "Bankadan cevap bekleniyor!";
        contenttext = "Bankadan ödeme cevabı bekleniyor. Lütfen ödeme durumunu daha sonra tekrar kontrol ediniz.";
    }

    const getStatusImage = () => {

        if (isSuccessPayment) {
            return (
                <img width="70" height="70" src="/images/success-green.svg" />
            );
        }
        else if (isErrorPayment) {
            return (
                <img width="70" height="70" src="/images/info-icon.svg" />
            );
        }
        else {
            return (
                <img width="70" height="70" src="/images/clockwise.png" />
            );
        }
    }
    const getInstallmentDesc = () => {

        let installment = 1;
        if (Installment > 0) {
            installment = Installment;
        }
        var installmentDesc = "Peşin";
        if (installment > 1) {
            installmentDesc = installment + " Taksit";
        }
        return installmentDesc;
    }

    const openPaymentSlip = () => {

        paymentSlipModalRef.current.showPaymentSlip({
            orderId: Orderid
        });
    }
    const copyTransactionId = () => {
        navigator.clipboard.writeText(TransactionId)
        toast.success("Değer başarılı bir şekilde kopyalandı");
    }
    const copyRefNo = () => {
        navigator.clipboard.writeText(ReferenceNumber)
        toast.success("Değer başarılı bir şekilde kopyalandı");
    }
    const goToPaymentPage = () => {

        props.goToPayment(true);
    }

    const boxWidthClass = "w-[500px] sm:w-[90%] xs:w-[90%]  sm_2:w-[90%]";


    const getContentArea = () => {

        return (
            <div className={`bg-white p-6 rounded-md shadow-lg text-dark-10 text-lg ${boxWidthClass}`}>
                <div className="items-center flex flex-col">
                    {getStatusImage()}
                    <label className={`text-4xl font-semibold mt-5 mb-8 text-center `}>
                        {header}
                    </label>
                </div>

                {isSuccessPayment ? (
                    <>
                        <div className="flex justify-between ">
                            <div className="">
                                Ödeme Tutarı:
                            </div>
                            <div className="">
                                {Amount} {CurrencySymbol}
                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <div className="">
                                Sipariş Numarası:
                            </div>
                            <div className=" flex items-center">
                                {TransactionId}

                                <FaCopy className="ml-2 cursor-pointer text-[#729aa5]" onClick={copyTransactionId}></FaCopy>
                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <div className="">
                                Banka Referans Kodu:
                            </div>
                            <div className=" flex items-center">
                                {ReferenceNumber}

                                <FaCopy className="ml-2 cursor-pointer text-[#729aa5]" onClick={copyRefNo}></FaCopy>

                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <div className="">
                                Taksit Sayısı:
                            </div>
                            <div className="  ">
                                {getInstallmentDesc()}
                            </div>
                        </div>
                    </>
                ) : isWaitPayment ? (
                    <div className="">
                        {contenttext}
                    </div>
                ) : (
                    <>
                        <div className="flex justify-between">
                            <div className="">
                                Hata Kodu:
                            </div>
                            <div className="  ">
                                {ErrorCode}

                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <div className="min-w-[120px]">
                                Hata Mesajı:
                            </div>
                            <div className="">
                                {ErrorMessage}
                            </div>
                        </div>
                    </>
                )}


            </div>
        );
    }

    const titleWidthClass = isWaitPayment ? "max-w-[300px]" : "max-w-[230px]";
    return (
        <div className="justify-center mt-14 flex flex-col mb-32 items-center " >
            <PaymentSlipModal ref={paymentSlipModalRef} isLoading={isLoading} setIsLoading={setIsLoading}></PaymentSlipModal>

            {getContentArea()}
            {isSuccessPayment && (

                <Button
                    type="submit"
                    color="primary"
                    hover="primary"
                    className={`mt-6 px-7 py-3 ${boxWidthClass}`}
                    size="xl"
                    callback={openPaymentSlip}
                    loading={isLoading}

                >
                    <span className="font-bold text-base">Dekont Görüntüle </span>
                </Button>
            )}
            {paymentPageType == "portal" && (
                <Button
                    type="submit"
                    color="gray"
                    hover="gray"
                    className={`mt-6 px-7 py-3 ${boxWidthClass}`}
                    size="xl"
                    callback={goToPaymentPage}
                >
                    <span className="font-bold text-base">Ödeme Sayfasına Dön </span>
                </Button>
            )}

        </div>
    );
}
export default PaymentResultV1